import { EventPageVisibility } from '@graphql/generated';

interface PageInfo {
  id: string;
  visibility: EventPageVisibility;
  photo?: {
    id: string;
    url: string;
  } | null;
}

export const getFirstValidPagePhoto = <T extends PageInfo>(pages: T[]): T['photo'] => {
  const page = pages.find(page => page.visibility !== EventPageVisibility.hidden && page.photo?.url);
  return page?.photo;
};
